import { OAuthState } from "./types";

export function encodeOAuthState(state: OAuthState): string {
  return btoa(JSON.stringify(state));
}

export function decodeOAuthState(encodedState: string): OAuthState {
  return JSON.parse(atob(encodedState));
}
